import { useEffect, useState } from 'react';

import classNames from 'classnames';

import type { BingoEventType } from '../../../../../stores/bingo/types';
import { formatTime } from '../../../../../utils/time';
import { useWidgetAdaptiveText } from '../../../hooks';

import styles from './BingoWidgetTimer.module.scss';

interface BingoWidgetTimerProps {
  eventId: string;
  bingoType: BingoEventType;
  startsInMs: number;
  extended?: boolean;
  newPlayer?: boolean;
}

const getContainerStyle = (bingoType: BingoEventType, extended?: boolean, newPlayer?: boolean) => {
  if (!extended) {
    return styles.container;
  }
  if (newPlayer) {
    return classNames(
      styles.containerExtended,
      bingoType === 'CASUAL' ? styles.containerCasual : styles.containerSweeps,
    );
  }
  return styles.containerExtended;
};

export function BingoWidgetTimer(props: BingoWidgetTimerProps) {
  const { bingoType, startsInMs, extended, eventId, newPlayer } = props;
  const [timeLeft, setTimeLeft] = useState(startsInMs);
  const { textRef } = useWidgetAdaptiveText({ padding: 4 });
  const containerStyle = getContainerStyle(bingoType, extended, newPlayer);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => Math.max(0, prev - 1000));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (eventId) {
      setTimeLeft(startsInMs);
    }
  }, [eventId, startsInMs]);

  return (
    <div className={containerStyle} data-testid="bingo-next-event-countdown">
      <span ref={textRef} className={extended ? styles.textExtended : styles.text}>
        {formatTime(timeLeft, 'ms')}
      </span>
    </div>
  );
}
